<div class="grid grid-password-login">
    <div id='password-header'>{{trans('auth.form.enterPassword')}}</div>
    <app-password-edit [value]='password' (valueChanged)='password = $event' (enterClicked)='passwordSubmit()' [doFocus]='true' id='password-form'>{{trans('auth.form.password')}}</app-password-edit>
    <div id='password-forgot' (click)='resetPassword()'>{{trans('auth.buttons.forgotPassword')}}</div>
</div>